export const truncateToDecimals = (value: string, n: number) => {
    if (typeof value !== "string" || typeof n !== "number" || n < 0) {
        return value;
    }

    // Replace comma with a dot for processing
    const normalizedValue = value.replace(",", ".");

    // Convert to number
    const num = Number.parseFloat(normalizedValue);

    if (Number.isNaN(num)) {
        return value;
    }

    // Truncate to one decimal place
    const factor = 10 ** n;
    const truncated = Math.trunc(num * factor) / factor;

    // Return as string with original decimal separator
    return value.includes(",")
        ? truncated.toString().replace(".", ",")
        : truncated.toString();
};
